import { API_ENDPOINTS } from "../../constants/apiEndpoints";
import { ENVIRONMENT_CONFIG } from "../../constants/environmentConfig";
import fetcher from "../../helpers/fetcher";

export const getBCHDivisionAndRegion = async () => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.EXTERNAL_DATA.GET_BCH_CONSTANTS,
      {},
      undefined,
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};